import { MOBILE } from '@app/constants';

export const useUserIntegrationsTab = () => {
  const isMobile = innerWidth <= MOBILE;

  return {
    isMobile,
  };
};
